import styled from 'styled-components';

export const ClientSelector = styled.nav`
  max-width: 1300px;
  margin: 0 auto;
  padding-top: 2.5rem;
  display: grid;
  grid-template-columns: 40rem auto;
`;
